import { useUserInfo } from "@/context/UserInfo";
import { Box, useDisclosure } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Order } from "@/api/order";
import SelectAccount from "./SelectAccount";
import WithdrawDetail from "./WithdrawDetail";
import {
  createExternalAccount,
  ExternalAccount,
  getExternalAccount,
  getLiquidationAddress,
} from "@/api/bridge";

const LOCAL_ORDERS_KEY = "local_withdrawal_orders";

// 添加保存本地订单的函数
export const saveLocalWithdrawalOrder = (order: Order) => {
  const existingOrders = localStorage.getItem(LOCAL_ORDERS_KEY);
  const orders = existingOrders ? JSON.parse(existingOrders) : [];
  orders.push(order);
  localStorage.setItem(LOCAL_ORDERS_KEY, JSON.stringify(orders));
};

const Withdraw = () => {
  const { usdcBalance, smartAccount, address, senderAddress, bridgeCustomer } =
    useUserInfo();

  const {
    isOpen: isOpenNewBank,
    onClose: onCloseNewBank,
    onOpen: onOpenNewBank,
  } = useDisclosure();
  const [bankList, setBankList] = useState<any[]>([]);
  const [liquidationList, setLiquidationList] = useState<any[]>([]);
  const [bankErrorMessage, setBankErrorMessage] = useState<string>("");

  const [withdrawMethod, setWithdrawMethod] = useState<"bank" | "wallet">(
    "bank"
  );
  const [step, setStep] = useState(0);
  const [withdrawAddress, setWithdrawAddress] = useState<string>("");
  const navigate = useNavigate();
  const [selectBank, setSelectBank] = useState<ExternalAccount | null>(null);
  const handleWithdrawBank = () => {
    if (bridgeCustomer?.status === "active") {
      setWithdrawMethod("bank");
      setStep(1);
    } else if (bridgeCustomer?.id) {
      navigate("/verifyInfo");
    } else {
      navigate("/createKyc");
    }
  };

  const handleWithdrawWallet = (address: string) => {
    setStep(1);
    setWithdrawAddress(address);
    setWithdrawMethod("wallet");
  };

  const handleGetBankInfo = async () => {
    const bankInfo = await getExternalAccount();
    setBankList(bankInfo);
  };

  const handleGetLiquidationAddress = async () => {
    const liquidationAddress = await getLiquidationAddress();
    setLiquidationList(liquidationAddress);
  };

  const handleSelectBank = (bank: ExternalAccount) => {
    setSelectBank(bank);
    setWithdrawMethod("bank");
    setStep(1);
  };

  const handleCreateBank = async (payload: any) => {
    try {
      await createExternalAccount(payload);
      const bankInfo = await getExternalAccount();
      setBankList(bankInfo);
      onCloseNewBank();
    } catch (error) {
      const message = (error as any).data.message;
      setBankErrorMessage(message);
    }
  };

  const resetBankErrorMessage = () => {
    setBankErrorMessage("");
  };

  useEffect(() => {
    if (bridgeCustomer?.status === "active") {
      handleGetBankInfo();
      handleGetLiquidationAddress();
    }
  }, [bridgeCustomer]);

  console.log(liquidationList, "liquidationAddress");

  return (
    <Box>
      {step === 0 && (
        <SelectAccount
          bankList={bankList}
          onWithdrawBank={handleWithdrawBank}
          onWithdrawWallet={(address) => {
            handleWithdrawWallet(address);
          }}
          handleSelectBank={handleSelectBank}
          handleCreateBank={handleCreateBank}
          bankErrorMessage={bankErrorMessage}
          resetBankErrorMessage={resetBankErrorMessage}
          isOpenNewBank={isOpenNewBank}
          onCloseNewBank={onCloseNewBank}
          onOpenNewBank={onOpenNewBank}
        />
      )}
      {step === 1 && (
        <WithdrawDetail
          withdrawAddress={withdrawAddress}
          onBack={() => setStep(0)}
          withdrawMethod={withdrawMethod}
          selectBank={selectBank}
          liquidationList={liquidationList}
          handleGetLiquidationAddress={handleGetLiquidationAddress}
        />
      )}
    </Box>
  );
};

export default Withdraw;
